import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitaliz' })
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
